<section
  id="header"
  class="relative m-1 md:m-8 bg-cover bg-center h-screen flex flex-col justify-center items-start p-4 md:p-8"
  style="background-image: url('/img-header.jpeg'); border-radius: 40px; md:border-radius: 60px;"
>
  <!-- Overlay -->
  <div
    class="absolute inset-0 bg-black opacity-60 rounded-2xl md:rounded-3xl"
    style="border-radius: 40px; md:border-radius: 60px;"
  ></div>

  <!-- Texto alineado a la izquierda -->
  <h1 class="hidden">
    BIOS Ingeniería
  </h1>
  
  <div class="font-clashg relative z-10 text-white text-4xl md:text-6xl font-medium text-left mb-4 md:mb-8 leading-snug md:leading-tight ml-4 md:ml-8">
    <p>La Seguridad Es Nuestra Meta,</p>
    <p>Cuál Es La Tuya?</p>
  </div>
  <!-- Botones -->
  <div class="relative z-10 flex flex-col sm:flex-row gap-4 ml-4 md:ml-8">
    <a
      href="#services"
      class="bg-Blue text-white text-md px-4 py-3 md:px-6 md:py-3 rounded-xl md:rounded-2xl hover:bg-blue-800 transition duration-300 font-bold"
    >
      Nuestros Servicios
    </a>
    <a
      href="#contact"
      class="bg-gray-100 text-black text-md px-4 py-3 md:px-6 md:py-3 rounded-xl md:rounded-2xl hover:bg-gray-400 transition duration-300 font-bold"
    >
      Contáctanos
    </a>
  </div>
</section>
